import { TextField } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { FC } from 'react'

import { DICTIONARY } from '../../../constants/dictionary'
import { Identifiers } from '../../../model/Quote'
import { ShowroomFiltersResponse } from '../../../model/ShowroomFiltersResponse'
import { capitalize } from '../../../utils/string'
import AutocompleteSelect from '../component/autocomplete/AutocompleteSelect'
import { useShowroomConfig } from '../context/ShowroomContext'

interface Props {
  filtersResponse: ShowroomFiltersResponse
}

const CategoryTypesFilter: FC<Props> = ({ filtersResponse }) => {
  const { state, dispatch } = useShowroomConfig()
  const { t } = useTranslation()

  return (
    <AutocompleteSelect
      dataE2eId="CategoryTypesFilter"
      hint={{
        title: t(DICTIONARY.VEHICLE_CATEGORY),
        text: t(DICTIONARY.CATEGORY_FILTER_TOOLTIP),
      }}
      value={state.filters.carCategories}
      onChange={(_, newValue: unknown) =>
        dispatch({
          type: 'updateCategoryTypes',
          filters: { carCategories: newValue as Identifiers[] },
        })
      }
      getOptionLabel={(o) => (o as Identifiers).text}
      renderOption={(option: unknown) => (
        <div>{(option as Identifiers).text}</div>
      )}
      options={filtersResponse.carCategories}
      renderInput={(params) => (
        <TextField
          {...(params as Record<string, unknown>)}
          label={capitalize(t(DICTIONARY.VEHICLE_CATEGORY))}
          placeholder={t(DICTIONARY.SELECT_CATEGORY_TYPES)}
        />
      )}
    />
  )
}

export default CategoryTypesFilter
